module.exports = __webpack_public_path__ + "static/media/circleQuestion.8e6e4d22.svg";